import React, { useEffect } from "react";
import DashboardComponent from "./dashboard";
import { societyList } from "../../redux/slice/societyListSlice";
import { connect } from "react-redux";
import { dashboardSocietyCount } from "../../redux/slice/dashboardSocietyCountSlice";
import PageLoader from "../common/pageLoader";
import { dashboardActivities } from "../../redux/slice/dashboardActivitiesSlice";
import { Cookies } from "react-cookie";
import { societyStatusGraph } from "../../redux/slice/societyStatusGraphSlice";
import { societyUsersGraph } from "../../redux/slice/societyUsersGraphSlice";

const Dashboard = (props) => {
  const {
    societyListData,
    callsocietyListData,
    dashboardSocietyCountData,
    calldashboardSocietyCountData,
    calldashboardActivitiesData,
    dashboardActivitiesData,
    callsocietyStatusGraphData,
    societyStatusGraphData,
    callsocietyUsersGraphData,
    societyUsersGraphData
  } = props;

  const loading = dashboardSocietyCountData.isLoading || societyStatusGraphData.isLoading || societyUsersGraphData.isLoading;
  const cookies = new Cookies();

  const society_count =
    (dashboardSocietyCountData &&
      dashboardSocietyCountData.dashboardSocietyCountData &&
      dashboardSocietyCountData.dashboardSocietyCountData.data) ||
    null;

    const society_status = (societyStatusGraphData &&
      societyStatusGraphData.societyStatusGraphData &&
      societyStatusGraphData.societyStatusGraphData.data) ||
    null;;
    
    const society_status_counts = society_status?.this_year?.map(item => item.count) || [];

    const society_users_graph = (societyUsersGraphData &&
      societyUsersGraphData.societyUsersGraphData &&
      societyUsersGraphData.societyUsersGraphData.data) ||
    null;;
    
    const society_users_counts = society_users_graph?.this_year?.map(item => item.count) || [];
  const dashboardActivities =
    (dashboardActivitiesData &&
      dashboardActivitiesData.dashboardActivitiesData &&
      dashboardActivitiesData.dashboardActivitiesData.data &&
      dashboardActivitiesData.dashboardActivitiesData.data.data) ||
    [];
  useEffect(() => {
    const validateToken = async () => {
      const token = cookies.get("token");

      if (token) {
         calldashboardSocietyCountData();
         calldashboardActivitiesData();
         callsocietyStatusGraphData()
         callsocietyUsersGraphData()
      } 
    };
    validateToken();
  }, []);

  return (
    <>
      {loading && <PageLoader />}
      <DashboardComponent
        societyListData={societyListData}
        callsocietyListData={callsocietyListData}
        society_count={society_count}
        dashboardActivities={dashboardActivities}
        society_status_counts={society_status_counts}
        society_users_counts={society_users_counts}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    societyListData: state.societyListData,
    dashboardSocietyCountData: state.dashboardSocietyCountData,
    dashboardActivitiesData: state.dashboardActivitiesData,
    societyStatusGraphData: state.societyStatusGraphData,
    societyUsersGraphData: state.societyUsersGraphData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    callsocietyListData: (id) => dispatch(societyList(id)),
    calldashboardSocietyCountData: () => dispatch(dashboardSocietyCount()),
    calldashboardActivitiesData: () => dispatch(dashboardActivities()),
    callsocietyStatusGraphData: () => dispatch(societyStatusGraph()),
    callsocietyUsersGraphData: () => dispatch(societyUsersGraph()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
